import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { TituloEntidade } from './tituloForm'
import {
    changeQuantidadeEmpresaHsCom,
    changeQuantidadeFuncionarioHsCom,
    changeQuantidadeUsuarioHsCom,
    changeQuantidadeEquipamentoHsCom,
    changeDataFimLicencaHsCom,
    changeSituacaoHsCom,
} from '../actions/actionEntidadeHsCom';

const ROLE_SYSTEM = "System";
const ROLE_ADM = "Admin";
const ROLE_User = "User";


Modal.setAppElement('#root');

class HSCom extends Component {
    constructor(state) {
        super(state);
        this.state = {
            situacao: this.props.situacaoHsCom,
            quantidadeEmpresas: this.props.quantidadeEmpresasHsCom,
            quantidadeFuncionarios: this.props.quantidadeFuncionariosHsCom,
            quantidadeUsuarios: this.props.quantidadeUsuariosHsCom,
            quantidadeEquipamentos: this.props.quantidadeEquipamentosHsCom,
            dataFimLicenca: this.props.dataFimLicencaHsCom
        }

        this.atribuiSituacao = this.atribuiSituacao.bind(this);
        this.atribuiEmpresas = this.atribuiEmpresas.bind(this);
        this.atribuiFuncionarios = this.atribuiFuncionarios.bind(this);
        this.atribuiUsuarios = this.atribuiUsuarios.bind(this);
        this.atribuiEquipamentos = this.atribuiEquipamentos.bind(this);
        this.atribuiDataFimLicenca = this.atribuiDataFimLicenca.bind(this);
    }


    verificaRole() {
        switch (this.props.currentRole) {
            case ROLE_SYSTEM:
                return true;
            case ROLE_ADM:
                return true;
            case ROLE_User:
                return false;
            default:
                return false
        }
    }

    atribuiSituacao(event){
        let situacao = event.target.value;

        this.setState({ situacao });
        this.props.changeSituacaoHsCom(situacao)
    }

    atribuiEmpresas(event){
        let quantidadeEmpresas = event.target.value;

        this.setState({ quantidadeEmpresas });
        this.props.changeQuantidadeEmpresaHsCom(quantidadeEmpresas)
    }

    atribuiFuncionarios(event){
        let quantidadeFuncionarios = event.target.value;

        this.setState({ quantidadeFuncionarios });
        this.props.changeQuantidadeFuncionarioHsCom(quantidadeFuncionarios)
    }

    atribuiUsuarios(event){
        let quantidadeUsuarios = event.target.value;

        this.setState({ quantidadeUsuarios });
        this.props.changeQuantidadeUsuarioHsCom(quantidadeUsuarios)
    }

    atribuiEquipamentos(event){
        let quantidadeEquipamentos = event.target.value;

        this.setState({ quantidadeEquipamentos });
        this.props.changeQuantidadeEquipamentoHsCom(quantidadeEquipamentos)
    }

    atribuiDataFimLicenca(event){
        let dataFimLicenca = event.target.value;

        this.setState({ dataFimLicenca });
        this.props.changeDataFimLicencaHsCom(dataFimLicenca)
    }
    
    render() {
        let disabled = this.verificaRole() ? false : true;

        return (
            <>
                <TituloEntidade titulo="HSCom"/>
                <hr/>
                <div className="form-row margemFormulario">
                    <div className="form-group col-12 col-sm-3">
                        <label> Situação: </label>
                        <select
                            disabled={disabled}
                            id='situacaoEntidade'
                            name='situacaoEntidade'
                            className={this.state.situacao === "Selecione" ? 'form-control is-invalid' : 'form-control'}
                            value={this.state.situacao}
                            onChange={this.atribuiSituacao}>
                            <option defaultValue> Selecione</option>
                            <option value='0'>Bloqueado</option>
                            <option value='1'>Liberado</option>
                        </select>
                        <div className='invalid-feedback'>
                            {this.state.situacao === "Selecione" ? "Selecione uma opção" : null}
                        </div>
                    </div>
                    <div className="form-group col-12 col-sm-3">
                        <label> Quantidade de Empresas: </label>
                        <input
                            disabled={disabled}
                            type="number"
                            id="quantidadeEmpresas"
                            name="quantidadeEmpresas"
                            className='form-control'
                            autoComplete="off"
                            value={this.state.quantidadeEmpresas}
                            onChange={this.atribuiEmpresas} />
                    </div>

                    <div className="form-group col-12 col-sm-3">
                        <label> Quantidade de Funcionarios: </label>
                        <input
                            disabled={disabled}
                            type="number"
                            id="quantidadeFuncionarios"
                            name="quantidadeFuncionarios"
                            className='form-control'
                            autoComplete="off"
                            value={this.state.quantidadeFuncionarios}
                            onChange={this.atribuiFuncionarios} />
                    </div>

                    <div className="form-group col-12 col-sm-3">
                        <label> Quantidade de Usuários: </label>
                        <input
                            type="number"
                            id="quantidadeUsuarios"
                            name="quantidadeUsuarios"
                            className='form-control'
                            autoComplete="off"
                            value={this.state.quantidadeUsuarios}
                            onChange={this.atribuiUsuarios}
                            disabled={disabled} />
                    </div> 
                </div>
                <div className="form-row margemFormulario">
                    <div className="form-group col-12 col-sm-3">
                        <label> Data final da licença </label>
                        <input
                            type="date"
                            id="dataFimLicenca"
                            name="dataFimLicenca"
                            value={this.state.dataFimLicenca || ''}
                            onChange={this.atribuiDataFimLicenca}
                            className='form-control'
                            autoComplete='off'
                            disabled={disabled}
                        />
                    </div>
                    <div className="form-group col-12 col-sm-3">
                        <label> Quantidade de Equipamentos: </label>
                        <input
                            type="number"
                            id="quantidadeEquipamentos"
                            name="quantidadeEquipamentos"
                            className='form-control'
                            autoComplete="off"
                            value={this.state.quantidadeEquipamentos}
                            onChange={this.atribuiEquipamentos}
                            disabled={disabled} />
                    </div> 
                </div>
            </>
        );
    }
}


const mapStateToProp = (state) => ({
    currentRole: state.dadosRole.currentRole,

    situacaoHsCom: state.dadosEntidade.situacaoHsCom,
    quantidadeEmpresasHsCom: state.dadosEntidade.quantidadeEmpresasHsCom,
    quantidadeFuncionariosHsCom: state.dadosEntidade.quantidadeFuncionariosHsCom,
    quantidadeUsuariosHsCom: state.dadosEntidade.quantidadeUsuariosHsCom,
    quantidadeEquipamentosHsCom: state.dadosEntidade.quantidadeEquipamentosHsCom,
    dataFimLicencaHsCom: state.dadosEntidade.dataFimLicencaHsCom,
});

const mapActionstoProps = {
    changeQuantidadeEmpresaHsCom,
    changeQuantidadeFuncionarioHsCom,
    changeQuantidadeUsuarioHsCom,
    changeQuantidadeEquipamentoHsCom,
    changeDataFimLicencaHsCom,
    changeSituacaoHsCom,
}

export default connect(mapStateToProp, mapActionstoProps)(HSCom);